import _ from 'lodash';
import React from 'react';
import styles from './index.module.scss';

const WEEK_DAYS: any = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

const LabelField = ({ value }: { value: string | number }) => (
  <div className={styles['label']}>{value}</div>
);
const WorkingDaysConfig = props => {
  let { workingDays }: { workingDays } = props;
  const {
    onChange, text,
  } = props;
  const handleCheckBoxChange = async (index: number, checked: boolean) => {
    if (checked) {
      workingDays = [...workingDays, index];
    }
    else {
      workingDays = workingDays.reduce((p, c) => (c !== index && p.push(c), p), []);
    }
    onChange(workingDays);
  };

  const renderedDays = () => {
    return (
      <div className={'mt-3'}>
        {
          WEEK_DAYS.map((value, i) => (
            <div key={i} className={styles['day-group']}>
              <input
                type={'checkbox'}
                checked={workingDays.includes(i)} // 0 is sunday and 6 is saturday
                onChange={e => handleCheckBoxChange(i, e.target.checked)}
              />
              <div className={styles['day-name']}>{value}</div>
            </div>
          ))
        }
      </div>
    );
  };
  return (<>
    <LabelField value={text} />
    {renderedDays()}
  </>);
};

export default WorkingDaysConfig;
